module.exports = __webpack_public_path__ + "img/32_newYouth_zx.b19cff93.png";